import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ColorThief from "colorthief";
import { CollectionCardProps } from './collection-card-types';
import {
    CardContainer,
    UpperSection,
    CollectionImage,
    CollectionInfo,
    CollectionName,
    CollectionCount,
    LowerSection,
    CollectiblePreview,
    CollectibleImage,
    MoreCollectibles
} from './style-component';
import { useTheme } from '@/contexts/theme-context/useThemeContext';

const CollectionCard: React.FC<CollectionCardProps> = ({
    thumb_url,
    name,
    collectibles_count,
    collectibles,
    collection_key
}) => {
    const navigate = useNavigate();
    const theme = useTheme();
    const { contentBg = "#17242B80" } = theme?.theme?.colors?.theme || {};
    const [backgroundColor, setBackgroundColor] = useState<string>(contentBg);
    const displayedCollectibles = collectibles?.slice(0, 5);
    const hasMore = collectibles?.length > 5;

    useEffect(() => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = thumb_url;
        
        img.onload = () => {
            const colorThief = new ColorThief();
            const dominantRGB = colorThief.getColor(img);
            setBackgroundColor(`rgba(${dominantRGB[0]}, ${dominantRGB[1]}, ${dominantRGB[2]}, 0.5)`);
        };
    }, [thumb_url]);

    const handleClick = () => {
        navigate(`/collection/${collection_key}`);
    };

    return (
        <CardContainer
            onClick={handleClick}
            style={{ 
                cursor: 'pointer',
                background: backgroundColor 
            }}
        >
            <UpperSection>
                <CollectionImage src={thumb_url} alt={name} />
                <CollectionInfo>
                    <CollectionName>{name}</CollectionName>
                    <CollectionCount>
                        {collectibles_count} {collectibles_count === 1 ? 'coleccionable' : 'coleccionables'}
                    </CollectionCount>
                </CollectionInfo>
            </UpperSection>
            
            <LowerSection>
                {displayedCollectibles.map((collectible, index) => {
                    if (index === 4 && hasMore) {
                        return (
                            <MoreCollectibles key="more">
                                +{collectibles.length - 4}
                            </MoreCollectibles>
                        );
                    }
                    return (
                        <CollectiblePreview key={index}>
                            <CollectibleImage 
                                src={collectible.thumb_url} 
                                alt={`Collectible ${index + 1}`} 
                            />
                        </CollectiblePreview>
                    );
                })}
            </LowerSection>
        </CardContainer>
    );
};

export default CollectionCard;